export const ASYNC_START = 'ASYNC_START';
export const ASYNC_END = 'ASYNC_END';
export const REDIRECT = 'REDIRECT';
